import { Hub } from "@aws-amplify/core";

const RETURN_TO = "returnTo";

export const setReturnToUrl = (returnTo?: string) => {
  const p = window.location.pathname;
  if (p.startsWith("/auth/")) return;
  const href =
    returnTo ??
    window.location.pathname + window.location.search + window.location.hash;
  if (!sameOrigin(href)) return;
  if (isAuthUtilityPath(new URL(href, window.location.origin).pathname)) return;
  try {
    const existing = sessionStorage.getItem(RETURN_TO);
    if (existing === href) return;
    sessionStorage.setItem(RETURN_TO, href);
    sessionStorage.setItem("Origin", window.location.origin);
  } catch {}
};
export const getReturnToUrl = () => {
  try {
    return sessionStorage.getItem(RETURN_TO);
  } catch {
    return null;
  }
};
export const sameOrigin = (href: string) => {
  try {
    const url = href.startsWith("/")
      ? new URL(href, window.location.origin)
      : new URL(href);
    return url.origin === window.location.origin;
  } catch {
    return false;
  }
};
const isAuthUtilityPath = (p: string) => {
  return p === "/" || p.startsWith("/auth/");
};
export const attachAuthHubListner = () => {
  let attached = false;
  if (attached) return;
  attached = true;
  Hub.listen("auth", ({ payload }) => {
    const { event, data } = payload || {};
    if (event === "customOAuthState" && typeof data === "string") {
      sessionStorage.removeItem("RETURN_TO");
      window.location.replace(data);
      return;
    }
    if (event === "signIn" || event === "cognitoHostedUI") {
      const rt = sessionStorage.getItem(RETURN_TO);
      if (
        rt &&
        rt !==
          window.location.pathname +
            window.location.search +
            window.location.hash
      ) {
        sessionStorage.removeItem(RETURN_TO);
        window.location.replace(rt);
      }
    }
  });
};
